class UpdateRootVars {
  constructor() {
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  bindUI() {
    this.ui = {};
    this.ui.$headerEl = document.querySelector('.js-header');
  }

  bindEvents() {
    // Update header height root var for sticky toc top position
    document.documentElement.style.setProperty('--header-height', `${this.ui.$headerEl.offsetHeight}px`);

    window.addEventListener('resize', this.onResize.bind(this));
  }

  onResize() {
    document.documentElement.style.setProperty('--header-height', `${this.ui.$headerEl.offsetHeight}px`);
  }
}

export default UpdateRootVars;

new UpdateRootVars();
